<template>
    <div>
        <el-table
          ref="filterTable"
          :data="dataShow"
          style="width: 100%"
          @sort-change="sortChange">
            <el-table-column
              prop="number"
              :label="$t('Main.number')"
              width="180">
            </el-table-column>
            <el-table-column
              prop="projectName"
              :label="$t('Main.projectName')"
              width="180">
            </el-table-column>
            <el-table-column
              prop='fileList'
              :label="$t('Main.DiagnoseFiles')"
              :formatter="handleAgencys">
            </el-table-column>
            <el-table-column
              prop="createTime"
              :label="$t('Main.CreateTime')"
              sortable="custom"
              column-key="date">
            </el-table-column>
            <el-table-column
              prop="diagnosisStatus"
              :label="$t('Main.Status')"
              sortable="custom">
              <template slot-scope="scope">{{ scope.row.diagnosisStatus==true?$t('Main.Diagnosed'):$t('Main.Diagnosing') }}</template>
            </el-table-column>
            <el-table-column
              prop="updateTime"
              :label="$t('Main.DiagnoseTime')"
              sortable="custom"
              column-key="date">
            </el-table-column>
            <el-table-column
              prop="diagnosisReport"
              :label="$t('Main.DiagnoseReport')"
              width="180">
                <template slot-scope="scope">
                    <div
                      v-if="!scope.row.diagnosisStatus"
                      :style="{
                      color: scope.row.diagnosisReport !='null'?'blue':'blue'}">
                        <ProgressBar :progress=scope.row.diagnosisReport :width="100" style="display:inline-block;text-align: center;"/>  
                    </div>
                    <div
                      @click="loadFile(scope.row.reportPath,scope.row.diagnosisReport)" 
                      v-if="scope.row.diagnosisStatus"
                      :style="{
                      color: scope.row.diagnosisReport !='null'?'blue':'blue'}">
                        {{ scope.row.diagnosisReport }}
                    </div>
                </template>
          </el-table-column>
        </el-table>
        <PaginationWidget :total-number="dataSelect.length" @changePage="changePage($event)" @changeSize="changeSize($event)"/>
    </div>
</template>
  
<script>
import PaginationWidget from './PaginationWidget.vue' 
import ProgressBar from './Utils/ProgressBar.vue'
export default{
  name: 'DataTable',
  props:{
    dataSelect:{
      type:Array,
      required:true,
    },
    isReset:{
      type:Boolean,
      required:true,
    }
  },
  components:{
    ProgressBar,
    PaginationWidget
  },
  data() {
    return {
      prop:'',
      order:'',
      pageSize:10,
      currentPage:1
    }
  },
  watch:{
    isReset:{
      handler(newVal){
        if(newVal==true){
          this.prop=''
          this.order=''
          this.pageSize = 10
          this.currentPage=1
          this.$refs.filterTable.clearSort();
          this.$emit('resetOver')
        }
      }
    }
  },
  computed:{
    dataShow:{
      get(){
        var dataFilter =[]
        this.dataSelect.forEach((item)=>{
          dataFilter.push(item)
        })
        if(this.prop!='' && this.order!='')
        dataFilter.sort(this.compare(this.prop, this.order));
        return dataFilter.slice(this.pageSize*(this.currentPage-1),this.pageSize*this.currentPage)
      }
    }
  },
  methods: {
    sortChange({ prop, order }) {
      this.prop=prop
      this.order=order
    },
    compare(propertyName, sort) {
      function isNumberV(val) {
        var regPos = /^\d+(\.\d+)?$/; //非负浮点数
        var regNeg =
          /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
        if (regPos.test(val) || regNeg.test(val)) {
          return true;
        } else {
          return false;
        }
      }
      return function (obj1, obj2) {
        var value1 = obj1[propertyName];
        var value2 = obj2[propertyName];
        if (!isNumberV(value1) && !isNumberV(value2)) {
          const res = value1.localeCompare(value2, "zh");
          return sort === "ascending" ? res : -res;
        } else {
          if (sort === "ascending") {
            return value1 - value2;
          } else {
            return value2 - value1;
          }
        }
      };
    },
    handleAgencys(row){
      let arr=[]
      row.fileList.forEach((element) => { 
      arr.push(element)
    })
    return arr.join(', ') 
    },
    loadFile (url1,url2) {
      window.open(url1+'/'+url2)
    },
    clearFilter() {
      this.$refs.filterTable.clearFilter();
    },
    formatter(row) {
      return row.address;
    },
    filterTag(value, row) {
      return row.tag === value;
    },
    filterHandler(value, row, column) {
      const property = column['property'];
      return row[property] === value;
    },
    changePage(curPage){
      this.currentPage=curPage
    },

    changeSize(curSize){
      this.pageSize=curSize
    },
  },
}
</script>
